import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { DEFAULT_CHECKED_VISIBILITY_FILTERS } from '../../pages/ManageTemplates/components/VisibilityFilter/constants';
import { getUserPrefs } from '../../utils/userPref';

interface TemplateFiltersState {
  isOpen: boolean;
  visibilityFilters: TemplateVisibilityValues[];
}

const existingUserPrefs = getUserPrefs();

export const initialState: TemplateFiltersState = {
  isOpen: false,
  visibilityFilters:
    existingUserPrefs.templateVisibilityFilters ||
    DEFAULT_CHECKED_VISIBILITY_FILTERS,
};

export const templateFiltersSlice = createSlice({
  initialState,
  name: 'templateFilters',
  reducers: {
    addVisibilityFilter: (
      state,
      action: PayloadAction<TemplateVisibilityValues>,
    ) => {
      state.visibilityFilters.push(action.payload);
    },
    deleteVisibilityFilter: (
      state,
      action: PayloadAction<TemplateVisibilityValues>,
    ) => {
      state.visibilityFilters = state.visibilityFilters.filter(
        (filter: TemplateVisibilityValues) => filter !== action.payload,
      );
    },
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
  },
});

export const {
  reducer: templateFiltersReducer,
  actions: { addVisibilityFilter, deleteVisibilityFilter, setIsOpen },
} = templateFiltersSlice;

const getTemplateFilters = (state: RootState) => state.templateFilters;

export const getIsOpen = createSelector(
  getTemplateFilters,
  ({ isOpen }) => isOpen,
);

export const getVisibilityFilters = createSelector(
  getTemplateFilters,
  ({ visibilityFilters }) => visibilityFilters,
);

export const templateFiltersSelectors = {
  getIsOpen,
  getVisibilityFilters,
};
